import { observable, action } from 'mobx';

import { Variables, ConnectionAppManager, AppRegistry } from 'core/index';

import { ProjectArrayApp } from 'apps/project/app';
import { ProfileProjectsQuery, ProjectPhaseQuery } from 'apps/project/gql';

import i18next from 'i18next';

export class ProjectConnManager extends ConnectionAppManager {
  static registryName = 'ProjectConnManager';
  static ArrayApp = ProjectArrayApp;
  @observable sortBy;
  @observable sortOptions;
  @observable filterBy;
  @observable phases;

  constructor(parent, init, options) {
    super(parent, init, options);
    this.initialBatchSize =
      init.initialBatchSize || this.arrayApp.cardLayout.initialBatchSize;
    this.batchSize = init.batchSize || this.arrayApp.cardLayout.batchSize;
    this.sortBy = init.sortBy || 'recent';
    this.sortOptions = init.sortOptions || [
      ['recent', i18next.t('Recent')],
      ['-stars', i18next.t('Stars')],
      ['contributions', i18next.t('Contributions')],
    ];
    this.filterBy = init.filterBy || [];
    this.contains = init.contains || [];
    this.notContains = init.notContains || [];
    this.whitelabels = init.whitelabels || [];
    this.variables = new Variables({
      sortBy: () => this.sortBy,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      featuredProjectsCount: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
      featuredProjectsCursor: () => this.endCursor,
      filterBy: () => this.filterBy,
      contains: () => this.contains,
      notContains: () => this.notContains,
      whitelabels: () => this.whitelabels,
    });
    this.loadMoreQuery = init.loadMoreQuery || ProfileProjectsQuery;
  }

  @action NewUsername() {
    this.Reset();
  }

  @action SetSort(sort) {
    this.sortBy = sort;
    this.Clear();
    this.loadMore();
  }

  @action QueryAllPhases = () => {
    const phasesQuery = new ProjectPhaseQuery(this);
    phasesQuery.process(result => result || null, this.UpdatePhases);
    phasesQuery.query();
  };

  @action UpdatePhases = phases => {
    if (!phases) return;
    phases.unshift({ id: '', name: 'All Phases' });
    this.phases = phases;
  };

  @action SetFilter(filter) {
    this.filterBy = filter;
    this.Clear();
    this.loadMore();
  }
}
AppRegistry.add(ProjectConnManager);

export class SuggestedProjectConnManager extends ConnectionAppManager {
  static registryName = 'SuggestedProjectConnManager';

  static ArrayApp = ProjectArrayApp;

  constructor(parent, init) {
    super(parent, init);
    this.batchSize = init.batchSize || this.arrayApp.cardLayout.batchSize;
    this.projectId = init.projectId;
    this.initialBatchSize = this.batchSize;

    this.variables = new Variables({
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
      cursor: () => this.endCursor,
      projectId: this.projectId,
    });

    this.loadMoreQuery = init.loadMoreQuery;
  }
}

AppRegistry.add(SuggestedProjectConnManager);
